import apiRequest from '../../utils/bccampusGraphQLRequest';
import { GetCoursesQuery, GetCourseByIdQuery, GetCourseBySlugQuery } from '../queries/Courses.graphql';

const read = async (key) => {
  if (key) {
    const parsedKey = Number(key);
    if (isNaN(parsedKey)) return await getBySlug(key);
    return await getById(key);
  } else {
    return await getAll();
  }
}

const getById = async (id) => {
  const variables = {
    id: id,
  };
  const result = await apiRequest(GetCourseByIdQuery, variables);
  return result.courses.length === 1 ? result.courses[0] : null;
}


const getBySlug = async (slug) => {
  const variables = {
    slug: slug,
  };
  const result = await apiRequest(GetCourseBySlugQuery, variables);
  return result.courses.length === 1 ? result.courses[0] : null;
}

const getAll = async () => {
  const result = await apiRequest(GetCoursesQuery);
  return result.courses;
}

const coursesRepository = { read, getAll };

export { read, getAll }
export default coursesRepository
